import { render } from "./HeaderPrestige.vue?vue&type=template&id=42960ab3"
import script from "./HeaderPrestige.vue?vue&type=script&lang=js"
export * from "./HeaderPrestige.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/reports/windowOverlay/reportInfo/HeaderPrestige.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "42960ab3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('42960ab3', __exports__)) {
    api.reload('42960ab3', __exports__)
  }
  
  module.hot.accept("./HeaderPrestige.vue?vue&type=template&id=42960ab3", () => {
    api.rerender('42960ab3', render)
  })

}


export default __exports__